import React from "react";
import { useState } from "react";
import { createUser, createConversation, sendMessage } from "@services/api";
import { useUser } from "@contexts/UserContext";
import { useConfig } from "@contexts/ConfigContext";
import ChatWindow from "@components/chat/ChatWindow";
import { initializeChatSession } from "@components/chat/utils";
import { ChatBubbleLeftRightIcon } from "@heroicons/react/24/solid";
import {
  chatButtonStyle,
  chatIconStyle,
  handleMouseEnter,
  handleMouseLeave,
  handleMouseDown,
  handleMouseUp
} from "./ChatButton.styles";



export default function ChatButton() {
  const { user, userId, saveUser } = useUser();
  const config = useConfig();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [conversation, setConversation] = useState(null);
  const [messages, setMessages] = useState([]);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  const handleFormSubmit = async (formData) => {
    setError(null);
    setIsLoading(true);

    try {
      const { user: newUser, conversation: newConversation, initialMessages } =
        await initializeChatSession({
          formData,
          createUserFn: (name, email) => createUser(name, email, config),
          createConversationFn: (userId, title) => createConversation(userId, title, config),
          sendMessageFn: (convId, userId, query) => sendMessage(convId, userId, query, config),
        });

      saveUser(newUser);
      setConversation(newConversation);
      setMessages(initialMessages);
    } catch (err) {
      console.error(err);
      setError("No se pudo iniciar el chat. Por favor, intenta nuevamente.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleMessagesUpdated = (updatedMessages) => {
    // Asegurarse de que updatedMessages es un array válido
    if (Array.isArray(updatedMessages)) {
      setMessages(updatedMessages);
    }
  };

  return (
    <React.Fragment>
      <button
        onClick={toggleChat}
        style={chatButtonStyle}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        aria-label="Abrir chat"
      >
        <ChatBubbleLeftRightIcon style={chatIconStyle} />
      </button>

      <ChatWindow
        isOpen={isOpen}
        onClose={toggleChat}
        user={user}
        conversation={conversation}
        messages={messages}
        onUserCreated={handleFormSubmit}
        onConversationCreated={setConversation}
        onMessagesUpdated={handleMessagesUpdated}
        isLoading={isLoading}
        formError={error}
      />
    </React.Fragment>
  );
}
